import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Card, Button, Form } from "react-bootstrap";
import { API_URL } from "../../../Constant.js";
import CounsellorNavbar from "../CounsellorLayout/CounsellorNavbar";
import CounsellorSidebar from "../CounsellorLayout/CounsellorSidebar";
import CounsellorFooter from "../CounsellorLayout/CounsellorFooter";

const COUNSELLOR_ID = 1;  // or from context / props

const CounsellorFees = () => {
  const [individualFirst, setIndividualFirst] = useState("");
  const [individualFollow, setIndividualFollow] = useState("");
  const [coupleFirst, setCoupleFirst] = useState("");
  const [coupleFollow, setCoupleFollow] = useState("");
  const [familyFirst, setFamilyFirst] = useState("");
  const [familyFollow, setFamilyFollow] = useState("");
  const [currency, setCurrency] = useState("INR");

  // Checkbox state
  const [enableIndividual, setEnableIndividual] = useState(false);
  const [enableCouple, setEnableCouple]       = useState(false);
  const [enableFamily, setEnableFamily]       = useState(false);

  // 1) Fetch existing fees on mount
  useEffect(() => {
    console.log("▶️ fetching existing counselling fees");
    const token = localStorage.getItem("token");
    fetch(`${API_URL}api/Counsellor/CounsellingFees/${COUNSELLOR_ID}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        console.log("   ↳ fetched fees:", data);
        data.forEach(fee => {
          switch (fee.sessionType) {
            case "Individual Counselling - First":
              setIndividualFirst(fee.amount.toString());
              setEnableIndividual(true);
              break;
            case "Individual Counselling - Follow":
              setIndividualFollow(fee.amount.toString());
              setEnableIndividual(true);
              break;
            case "Couple Counselling - First":
              setCoupleFirst(fee.amount.toString());
              setEnableCouple(true);
              break;
            case "Couple Counselling - Follow":
              setCoupleFollow(fee.amount.toString());
              setEnableCouple(true);
              break;
            case "Family Counselling - First":
              setFamilyFirst(fee.amount.toString());
              setEnableFamily(true);
              break;
            case "Family Counselling - Follow":
              setFamilyFollow(fee.amount.toString());
              setEnableFamily(true);
              break;
            default:
              break;
          }
        });
      })
      .catch(err => {
        console.error("   ❌ Error fetching fees:", err);
        toast.error("Failed to load existing fees.");
      });
  }, []);

  // 2) Save (PUT)
  const handleSave = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authentication failed. Please log in again.");
      return;
    }

    const now = new Date().toISOString();
    const payload = [];

    if (enableIndividual) {
      if (individualFirst)
        payload.push({
          counsellorId: COUNSELLOR_ID,
          sessionType:  "Individual Counselling - First",
          sessionTime:  60,
          amount:       parseFloat(individualFirst),
          currency,
          createdOn:    now,
          approvedBy:   COUNSELLOR_ID,
          approvedOn:   now
        });
      if (individualFollow)
        payload.push({
          counsellorId: COUNSELLOR_ID,
          sessionType:  "Individual Counselling - Follow",
          sessionTime:  60,
          amount:       parseFloat(individualFollow),
          currency,
          createdOn:    now,
          approvedBy:   COUNSELLOR_ID,
          approvedOn:   now
        });
    }

    if (enableCouple) {
      if (coupleFirst)
        payload.push({
          counsellorId: COUNSELLOR_ID,
          sessionType:  "Couple Counselling - First",
          sessionTime:  60,
          amount:       parseFloat(coupleFirst),
          currency,
          createdOn:    now,
          approvedBy:   COUNSELLOR_ID,
          approvedOn:   now
        });
      if (coupleFollow)
        payload.push({
          counsellorId: COUNSELLOR_ID,
          sessionType:  "Couple Counselling - Follow",
          sessionTime:  60,
          amount:       parseFloat(coupleFollow),
          currency,
          createdOn:    now,
          approvedBy:   COUNSELLOR_ID,
          approvedOn:   now
        });
    }

    if (enableFamily) {
      if (familyFirst)
        payload.push({
          counsellorId: COUNSELLOR_ID,
          sessionType:  "Family Counselling - First",
          sessionTime:  60,
          amount:       parseFloat(familyFirst),
          currency,
          createdOn:    now,
          approvedBy:   COUNSELLOR_ID,
          approvedOn:   now
        });
      if (familyFollow)
        payload.push({
          counsellorId: COUNSELLOR_ID,
          sessionType:  "Family Counselling - Follow",
          sessionTime:  60,
          amount:       parseFloat(familyFollow),
          currency,
          createdOn:    now,
          approvedBy:   COUNSELLOR_ID,
          approvedOn:   now
        });
    }

    console.log("▶️ [handleSave] payload:", payload);

    try {
      const res = await fetch(
        `${API_URL}api/Counsellor/CounsellingFees`,
        {
          method:  "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        }
      );
      const result = await res.json();
      console.log("   ↳ save response:", res.status, result);
      if (!res.ok) {
        toast.error(`Save failed: ${result.message || res.statusText}`);
      } else {
        toast.success("Fees saved successfully!");
      }
    } catch (err) {
      console.error("   ❌ Error saving fees:", err);
      toast.error("An error occurred while saving fees.");
    }
  };

  return (
    <>
      <ToastContainer />
      <CounsellorNavbar />
      <div className="d-flex">
        <CounsellorSidebar />
        <Card style={{ width: 700, margin: 20, padding: 20 }}>
          <h5>Set Session Fees</h5>
          <Form onSubmit={handleSave}>
            <Form.Group controlId="currency" className="mb-3">
              <Form.Label>Currency</Form.Label>
              <Form.Select
                value={currency}
                onChange={e => setCurrency(e.target.value)}
              >
                <option>INR</option>
                <option>USD</option>
                <option>EUR</option>
              </Form.Select>
            </Form.Group>

            {/* Individual */}
            <Form.Check
              type="checkbox"
              label="Individual Counselling"
              checked={enableIndividual}
              onChange={e => setEnableIndividual(e.target.checked)}
            />
            <Form.Group className="pl-3 mb-3">
              <Form.Label>First Session</Form.Label>
              <Form.Control
                type="number"
                value={individualFirst}
                onChange={e => setIndividualFirst(e.target.value)}
                disabled={!enableIndividual}
              />
              <Form.Label className="mt-2">Following Session</Form.Label>
              <Form.Control
                type="number"
                value={individualFollow}
                onChange={e => setIndividualFollow(e.target.value)}
                disabled={!enableIndividual}
              />
            </Form.Group>

            {/* Couple */}
            <Form.Check
              type="checkbox"
              label="Couple Counselling"
              checked={enableCouple}
              onChange={e => setEnableCouple(e.target.checked)}
            />
            <Form.Group className="pl-3 mb-3">
              <Form.Label>First Session</Form.Label>
              <Form.Control
                type="number"
                value={coupleFirst}
                onChange={e => setCoupleFirst(e.target.value)}
                disabled={!enableCouple}
              />
              <Form.Label className="mt-2">Following Session</Form.Label>
              <Form.Control
                type="number"
                value={coupleFollow}
                onChange={e => setCoupleFollow(e.target.value)}
                disabled={!enableCouple}
              />
            </Form.Group>

            {/* Family */}
            <Form.Check
              type="checkbox"
              label="Family Counselling"
              checked={enableFamily}
              onChange={e => setEnableFamily(e.target.checked)}
            />
            <Form.Group className="pl-3 mb-3">
              <Form.Label>First Session</Form.Label>
              <Form.Control
                type="number"
                value={familyFirst}
                onChange={e => setFamilyFirst(e.target.value)}
                disabled={!enableFamily}
              />
              <Form.Label className="mt-2">Following Session</Form.Label>
              <Form.Control
                type="number"
                value={familyFollow}
                onChange={e => setFamilyFollow(e.target.value)}
                disabled={!enableFamily}
              />
            </Form.Group>

            <div className="text-center">
              <Button type="submit">Save Fees</Button>
            </div>
          </Form>
        </Card>
      </div>
      <CounsellorFooter />
    </>
  );
};

export default CounsellorFees;
